import { render, staticRenderFns } from "./catalogBox.vue?vue&type=template&id=32a38549&scoped=true&"
import script from "./catalogBox.vue?vue&type=script&lang=js&"
export * from "./catalogBox.vue?vue&type=script&lang=js&"
import style0 from "./catalogBox.vue?vue&type=style&index=0&id=32a38549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a38549",
  null
  
)

export default component.exports